import {getProjectById} from 'Common/api';
import {Project} from 'Containers/Project';
import {useUserContext} from 'Contexts/UserContext/UserContext';
import React, {useMemo} from 'react';
import {useParams} from 'react-router-dom';
import useSWR from 'swr';
import {LoadAndErrorWrapper} from './LoadAndErrorWrapper';

interface Props {}

export const ProjectPage = (props: Props) => {
    const {userId} = useUserContext();
    const {projectId} = useParams() as {projectId: string};
    const args = useMemo(() => ({userId, projectId}), [projectId, userId]);
    const {data, isLoading, error} = useSWR(args, getProjectById);
    return (
        <LoadAndErrorWrapper loading={isLoading} errored={!!error}>
            <Project project={data!} />
        </LoadAndErrorWrapper>
    );
};
